import React from 'react';

const TermAndCodation = () => {
  return (
    <div id='term'>
          <div className=" container-lg  d-flex justify-content-center align-items-center p-5 ">
        <div className="contant bg-light rounded-4 h-80 text-center pt-4 px-5 ">
            <div className="pTerms ">
                <p>Privacy Policy

We highly value your privacy and are committed to protecting any personal information you provide to us through our mobile application. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal data. By using our app, you consent to the practices described in this policy.

Information Collection and Use:
We may collect certain personally identifiable information from you, such as your name, email address, and other contact details, when you voluntarily submit it through our app. This information is used to provide you with a personalized experience and to improve our services. We may also collect non-personal information, such as device information and usage data, to analyze trends and enhance app performance.

Data Sharing and Disclosure:
We do not sell, trade, or rent your personal information to third parties. However, we may share your information with trusted third-party service providers who assist us in operating our app and delivering services to you. These providers are bound by confidentiality agreements and are prohibited from using your information for any other purpose.

Data Security:
We employ industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, please note that no method of transmission or storage is 100% secure, and we cannot guarantee absolute security of your data.

Children's Privacy:
Our app is not intended for use by individuals under the age of 13. We do not knowingly collect personal information from children. If you believe we have inadvertently collected information from a child, please contact us immediately, and we will take appropriate steps to remove the information.

Updates to the Privacy Policy:
We reserve the right to modify this Privacy Policy at any time. Any changes will be effective immediately upon posting the updated policy within the app. We encourage you to review this policy periodically to stay informed about how we collect, use, and protect your information.

Contact Us:
If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at [contact email/phone number].

Remember, it's important to consult with legal professionals and ensure that your privacy policy complies with applicable laws and regulations in your jurisdiction.


We highly value your privacy and are committed to protecting any personal information you provide to us through our mobile application. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal data. By using our app, you consent to the practices described in this policy.

Information Collection and Use:
We may collect certain personally identifiable information from you, such as your name, email address, and other contact details, when you voluntarily submit it through our app. This information is used to provide you with a personalized experience and to improve our services. We may also collect non-personal information, such as device information and usage data, to analyze trends and enhance app performance.

Data Sharing and Disclosure:
We do not sell, trade, or rent your personal information to third parties. However, we may share your information with trusted third-party service providers who assist us in operating our app and delivering services to you. These providers are bound by confidentiality agreements and are prohibited from using your information for any other purpose.

Data Security:
We employ industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, please note that no method of transmission or storage is 100% secure, and we cannot guarantee absolute security of your data.

Children's Privacy:
Our app is not intended for use by individuals under the age of 13. We do not knowingly collect personal information from children. If you believe we have inadvertently collected information from a child, please contact us immediately, and we will take appropriate steps to remove the information.

Updates to the Privacy Policy:
We reserve the right to modify this Privacy Policy at any time. Any changes will be effective immediately upon posting the updated policy within the app. We encourage you to review this policy periodically to stay informed about how we collect, use, and protect your information.

Contact Us:
If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at [contact email/phone number].

Remember, it's important to consult with legal professionals and ensure that your privacy policy complies with applicable laws and regulations in your jurisdiction.
</p>
            </div>
            <div className="fw-bold py-3">
                <p>I agree to Sychoclinic<samp className="text-primary fs-5">Terms Conditions</samp> and acknowledge the
                    <samp className="text-primary fs-5">Privacy Policy</samp></p>
                    <a className="" href="login.html"><button className="px-3 py-2  btnCustom rounded-5">Accept</button></a> 
                    <a className="" href="index.html"><button className="px-3 py-2  btnCustom rounded-5">Decline</button></a>
            </div>

            
        </div>




    </div>


    </div>
  );
}

export default TermAndCodation;
